<template>
  <div class="contact-content">
    <div class="stamp"><img src="../../images/stamp.png"></div>
    <div v-html="gbl.content.contact" class="contact-content-content"/> 
  </div>
</template>

<script>
  export default {
    name: 'ContactPage',
    data() {
      return {
        gbl
      }
    },
  }
</script>


// WEBPACK FOOTER //
// resources/js/pages/ContactPage.vue